import {Component} from "preact";
import VerticalUiContainer from "../../../../../layout/vertical-ui-container";
import Toolbar from "../../../../../layout/toolbar";
import ToolbarTitle from "../../../../../layout/toolbar-title";
import Text from "../../../../../common/text";
import ScrollableSection from "../../../../../layout/scrollable-section";
import ToolbarButton from "../../../../../common/toolbar-button";
import ConfigService from "../../../../../../services/ConfigService";
import SectionComponent from "../../../../../layout/section-component";
import {translate} from "../../../../../../services/TranslateService";
import ArrowLeftIcon from "mdi-preact/ArrowLeftIcon";
import {execute} from "../../../../../../services/CallbackService";
import LanguageSelectorItem from "../language-selector-item";
import JWTClient from "../../../../../../services/JWTClient";

export default class LanguageSelector extends Component {
    static defaultProps = {
        onNavigate: () => {}
    };

    render(props, state, context) {
        const language = ConfigService.currentLanguage();
        const languageList = ConfigService.availableLanguages();
        if (languageList.length < 2) {
            setTimeout(this.backToProfile);
            return null;
        }

        return (
            <VerticalUiContainer>
                <Toolbar style={{borderBottom: '1px solid #eee'}}>
                    <SectionComponent style={{flexGrow: 0}}>
                        <ToolbarButton onClick={this.backToProfile} title={translate('action.back')}><ArrowLeftIcon/></ToolbarButton>
                    </SectionComponent>
                    <ToolbarTitle><Text text={'language_dropdown_title'}/></ToolbarTitle>
                </Toolbar>
                <ScrollableSection>
                    {languageList.map(i => (
                        <Toolbar>
                            <LanguageSelectorItem onClick={() => {this.updateLanguage(i)}} language={i} />
                        </Toolbar>
                    ))}
                </ScrollableSection>
            </VerticalUiContainer>
        );
    }

    backToProfile = () => {
        this.props.onNavigate('profile');
    };

    updateLanguage = (language) => {
        JWTClient.fetch(ConfigService.organigrammaServerUrl() + '/user-preference', {
            method: 'PUT',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                preference: "preferredLocale",
                value: language
            })
        }).then(() => {
            execute(() => ConfigService.setCurrentLanguage(language), () => {
                ConfigService.currentLanguage(language);
            });
            this.backToProfile();
        })
    };
}


// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/user/language-selector/index.js